<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('menu.pickShelfs'), $t('text.list')]"
      ></breadcrumb>
    </div>
    <narrow
      :narrows="narrows"
      :init-filter="initFilter"
      @narrowSelect="narrowSelect"
    />
    <div class="search with-narrows">
      <el-form
        :inline="true"
        @submit.native.prevent="search"
        :model="searchForm"
        size="small"
      >
        <el-form-item>
          <el-input
            v-model.trim="searchForm.associateSerialNo"
            :placeholder="$t('stock.associateSerialNo')"
            size="small"
          />
        </el-form-item>
        <el-form-item>
          <el-input
            v-model.trim="searchForm.productNo"
            :placeholder="$t('product.productNo')"
            size="small"
          />
        </el-form-item>

        <el-form-item>
          <el-input
            size="small"
            v-model.trim="searchForm.remark"
            :placeholder="$t('text.remark')"
          />
        </el-form-item>
        <date-range
          v-model="searchForm"
          type="datetime"
          field="create"
          :start-placeholder="$t('rules.startAt', [$t('text.createAt')])"
          :end-placeholder="$t('rules.endAt', [$t('text.createAt')])"
        />

        <el-form-item>
          <el-button
            type="primary"
            icon="el-icon-search"
            native-type="submit"
          />
        </el-form-item>
      </el-form>
    </div>
    <div class="wrapper table-area">
      <!-- <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" custom zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="primary" size="mini" @click="backPickShelf">
              {{ $t("action.pickShelf") }}
            </el-button>
            <span class="pager-total">
              {{ $t("rules.pagerTotal", [pager.total]) }}
            </span>
          </template>
        </vxe-toolbar>
      </sticky> -->

      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        :checkbox-config="{ reserve: true, checkMethod: checCheckboxMethod }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        :loading="loading"
        id="stockInsTable"
        row-id="id"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        resizable
        round
        auto-resize
        highlight-hover-row
        :scroll-y="{ enabled: false }"
      >
        <!-- <vxe-table-column
          field="checkbox"
          type="checkbox"
          width="35"
        ></vxe-table-column> -->
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="80"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.entity.images" v-if="row.entity != null" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="associateSerialNo"
          :title="$t('stock.associateSerialNo')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.entitySerialNo }}
            <div class="font10">
              {{ $t("pickShelfTypes." + row.entityType) }}
            </div>
          </template>
        </vxe-table-column>

        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <span v-if="row.entity != null">
              {{ row.entity.productNo }}
              <div class="font10">
                {{ row.entity.color }} {{ row.entity.size }}
              </div>
            </span>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <raw-html-limit-number :content="row.remark" :number="16" />
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
        <vxe-table-column
          field="dealName"
          :title="$t('pickShelf.dealName')"
          min-width="100"
        >
          <template v-slot="{ row }">
            {{ row.dealName }}
            <div class="font10">{{ row.dealAt }}</div>
          </template>
        </vxe-table-column>
        <!-- <vxe-table-column
          field="finishAt"
          :title="$t('pickShelf.finishAt')"
          width="110"
        /> -->
        <vxe-table-column
          field="action"
          :title="$t('text.action')"
          width="100"
          fixed="right"
        >
          <template v-slot="{ row }">
            <el-button
              v-if="row.dealAt == null"
              type="text"
              size="mini"
              @click="pickShelf(row)"
            >
              {{ $t("action.pickShelf") }}
            </el-button>
            <el-button
              v-if="row.dealAt == null"
              type="text"
              size="mini"
              @click="ignore(row)"
              :loading="ignoreDoing"
            >
              {{ $t("action.ignore") }}
            </el-button>
          </template>
        </vxe-table-column>
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          选中了
          <span class="strong">{{ selectRecordQty }}</span>
          条记录
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>

    <!-- 出库 -->
    <el-dialog
      :title="$t('action.pickShelf')"
      :close-on-click-modal="false"
      :visible.sync="pickShelfDF"
      width="30%"
    >
      <el-form ref="pickShelfObjForm" :model="pickShelfObj" label-width="80px">
        <el-form-item
          :label="$t('menu.warehouses')"
          :prop="'shelfId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.warehouses')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="pickShelfObj.shopId"
            filterable
            clearable
            @change="selectInventoryShop"
          >
            <el-option
              v-for="item of rowInventories"
              :key="item.shopId"
              :label="item.shopName"
              :value="item.shopId"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          :label="$t('menu.shelfs')"
          :prop="'shelfId'"
          :rules="[
            {
              required: true,
              message: $t('rules.required', [$t('menu.shelfs')]),
              trigger: 'blur',
            },
          ]"
        >
          <el-select
            size="small"
            v-model="pickShelfObj.shelfId"
            filterable
            clearable
            @change="selectInventoryShelf"
          >
            <el-option
              v-for="item of rowInventoryShelfs"
              :key="item.shelfId"
              :label="item.text"
              :value="item.shelfId"
            />
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          plain
          :loading="pickShelfSubmitDoing"
          size="small"
          @click="pickShelfSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="pickShelfDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
    <!-- 出库 -->
    <el-dialog
      :title="$t('action.pickShelf')"
      :close-on-click-modal="false"
      :visible.sync="batchPickShelfDF"
      width="60%"
    >
      <el-form
        ref="batchPickShelfObjForm"
        :model="batchPickShelfObj"
        label-width="80px"
      >
        <el-row>
          <el-col :span="12">
            <el-form-item
              :label="$t('menu.warehouses')"
              :prop="'shelfId'"
              :rules="[
                {
                  required: true,
                  message: $t('rules.required', [$t('menu.warehouses')]),
                  trigger: 'blur',
                },
              ]"
            >
              <el-select
                size="small"
                v-model="batchPickShelfObj.shopId"
                filterable
                clearable
                @change="selectInventoryShopBatch"
              >
                <el-option
                  v-for="item of shopsManage"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <vxe-table
          :data="selectRecords"
          size="mini"
          resizable
          round
          auto-resize
          highlight-hover-row
          :scroll-y="{ enabled: false }"
        >
          <vxe-table-column
            field="images"
            :title="$t('product.images')"
            width="80"
          >
            <template v-slot="{ row }">
              <thumbnail
                :images="row.entity.images"
                v-if="row.entity != null"
              />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="entitySerialNo"
            :title="$t('stock.associateSerialNo')"
            min-width="100"
          >
            <template v-slot="{ row }">
              {{ row.entitySerialNo }}
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="productNo"
            :title="$t('product.productNo')"
            min-width="80"
          >
            <template v-slot="{ row }">
              <div v-if="row.entity != null">
                {{ row.productNo }}
                <div class="font10">{{ row.color }} {{ row.size }}</div>
              </div>
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="quantity"
            :title="$t('text.quantity')"
            min-width="80"
          >
            <template v-slot="{ row }">
              {{ row.quantity }}
            </template>
          </vxe-table-column>

          <vxe-table-column
            field="remark"
            :title="$t('text.remark')"
            min-width="80"
          >
            <template v-slot="{ row }">
              <raw-html-limit-number :content="row.remark" :number="16" />
            </template>
          </vxe-table-column>
          <vxe-table-column
            field="_shelfId"
            :title="$t('menu.shelfs')"
            min-width="120"
          >
            <template v-slot="{ row }">
              <el-select
                size="mini"
                v-model="row._shelfId"
                filterable
                clearable
              >
                <el-option
                  v-for="item of shelfs"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                />
              </el-select>
            </template>
          </vxe-table-column>

          <vxe-table-column
            field="createAt"
            :title="$t('text.createAt')"
            width="110"
          />
          <vxe-table-column
            field="action"
            :title="$t('text.action')"
            width="50"
          >
            <template v-slot="{ row, rowIndex }">
              <el-button type="text" size="mini" @click="remove(row, rowIndex)">
                {{ $t("text.remove") }}
              </el-button>
            </template>
          </vxe-table-column>
        </vxe-table>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <span class="mgr10">
          {{ $t("text.total") }}：{{ countCurrnetTotal() }}
        </span>
        <el-button
          type="primary"
          plain
          :loading="batchPickShelfSubmitDoing"
          size="small"
          @click="batchPickShelfSubmit"
          >{{ $t("text.submit") }}</el-button
        >
        <el-button size="small" @click="batchPickShelfDF = false">{{
          $t("text.close")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import axios from "axios";
import Vue from "vue";
import { page, table } from "@/utils/mixins.js";
import Util from "@/utils/index.js";
import Thumbnail from "@/components/Thumbnail";
import DateRange from "@/components/DateRange";
import RawHtmlLimitNumber from "@/components/RawHtmlLimitNumber";
import RawHtml from "@/components/RawHtml";

import Shop from "@/api/shop.js";
import PickShelf from "@/api/pickShelf.js";
import Inventory from "@/api/inventory.js";
import InventoryForceOut from "@/api/inventoryForceOut.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    Thumbnail,
    RawHtmlLimitNumber,
    DateRange,
    RawHtml,
  },
  data() {
    return {
      Util: Util,
      narrows: [
        [
          {
            label: this.$t("pickShelf.dealInfo"),
            items: [
              {
                label: this.$t("dealInfo.yes"),
                key: "yes",
                condition: { deal: "yes" },
              },
              {
                label: this.$t("dealInfo.no"),
                key: "no",
                condition: { deal: "no" },
              },
            ],
          },
          {
            label: this.$t("text.type"),
            items: [
              {
                label: this.$t("pickShelfTypes.Purchase"),
                key: "Purchase",
                condition: { entityType: "Purchase" },
              },
              {
                label: this.$t("pickShelfTypes.Order"),
                key: "Order",
                condition: { entityType: "Order" },
              },
            ],
          },
        ],
      ],

      initFilter: "no",
      searchForm: {
        productNo: null,
        remark: null,
        createStartAt: null,
        createEndAt: null,
        associateSerialNo: null,
      },
      sorter: {
        sortBy: "inventoryForceOuts_id",
        sortIndicator: "desc",
      },
      shops: [],
      shopsInv: [],
      shopsView: [],
      shopsManage: [],

      ignoreDoing: false,
      //
      row: null,
      rowInventories: [],
      pickShelfDF: false,
      pickShelfObj: {
        shopId: null,
        shopName: null,
        shelfId: null,
        shelfName: null,
        // quantity: null,
        // remark: null,
        _maxQuantity: null,
      },
      rowInventoryShelfs: [],
      pickShelfSubmitDoing: false,
      //
      batchPickShelfDF: false,
      shelfs: [],
      batchPickShelfObj: {
        shopId: null,
      },
      batchPickShelfSubmitDoing: false,
    };
  },
  created() {
    const self = this;
    // this.$nextTick(() => {
    //   // 手动将表格和工具栏进行关联
    //   this.$refs.recordsTable.connect(this.$refs.recordsToolbar);
    // });
    axios.all([Shop.findByTenantId()]).then(
      axios.spread(function (shops) {
        if (shops.status === 200) {
          self.shops = shops.data;
          self.shopsInv = self.shops.filter((s) => s.isInventory == true);

          if (self.Permit.currentUser().admin) {
            self.shopsView = self.shopsInv;
            self.shopsManage = self.shopsInv;
          } else {
            self.shopsView = self.shopsInv.filter(
              (s) =>
                self.Permit.wmsViewShopIds().includes(s.id) &&
                s.isInventory == true
            );
            self.shopsManage = self.shopsInv.filter(
              (s) =>
                self.Permit.wmsManageShopIds().includes(s.id) &&
                s.isInventory == true
            );
          }
        } else {
          self.sysError();
        }
      })
    );
  },
  methods: {
    backPickShelf() {
      const self = this;
      if (self.selectRecords.length === 0) {
        this.$message.error(this.$t("prompt.atLeastOneData"));
        return;
      }
      self.batchPickShelfObj.shopId = [];
      self.shelfs = [];
      if (self.shopsManage.length == 1) {
        self.batchPickShelfObj.shopId = self.shopsManage[0].id;
        self.selectInventoryShopBatch();
      }
      self.batchPickShelfDF = true;
    },
    selectInventoryShopBatch() {
      const self = this;
      let obj = self.shopsManage.find(
        (s) => s.id == self.batchPickShelfObj.shopId
      );
      self.shelfs = obj.shelfs;
      for (const s of self.selectRecords) {
        if (self.shelfs.length == 1) {
          Vue.set(s, "_shelfId", self.shelfs[0].id);
        } else {
          Vue.set(s, "_shelfId", null);
        }
      }
    },
    remove(row, rowIndex) {
      this.selectRecords.splice(rowIndex, 1);
    },
    countCurrnetTotal() {
      let total = 0;
      if (this.selectRecords.length === 0) {
        return 0;
      }
      this.selectRecords.map((i) => {
        total += Number(i.quantity);
      });
      return total;
    },
    batchPickShelfSubmit() {
      const self = this;
      if (self.selectRecords.length === 0) {
        self.$message.error(self.$t("prompt.atLeastOneData"));
        return;
      }
      for (const i of self.selectRecords) {
        if (i._shelfId == null) {
          this.$message({
            message: self.$t("rules.select", [self.$t("menu.shelfs")]),
            type: "warning",
          });
          return;
        }
      }

      // const data = self.selectRecords.map((i) => {
      //   return {
      //     id: i.id,
      //     shopId: self.batchPickShelfObj.shopId,
      //     shelfId: i._shelfId,
      //   };
      // });
      // self.batchPickShelfSubmitDoing = true;
      // PickShelf.batchPick(data).then(function (res) {
      //   self.batchPickShelfSubmitDoing = false;
      //   if (res.status == 200) {
      //     self.sysResults(res.data, self.$t("prompt.pickSuccess"));
      //     self.loadData();
      //     self.batchPickShelfDF = false;
      //     self.$eventHub.$emit("pickShelfBatchPick");
      //   } else {
      //     self.sysError();
      //   }
      // });
    },

    // 出库
    pickShelf(row) {
      const self = this;
      self.row = row;
      self.pickShelfObj.shopId = null;
      self.pickShelfObj.shopName = null;
      self.pickShelfObj.shelfId = null;
      self.pickShelfObj.quantity = null;
      self.pickShelfObj.remark = null;
      let obj = {
        productNo: row.entity.productNo,
        color: row.entity.color,
        size: row.entity.size,
      };
      Inventory.findByProductInfoWithoutShop(obj).then(function (res) {
        if (res.status == 200) {
          self.rowInventories = res.data.filter((r) =>
            self.shopsManage.map((s) => s.id).includes(r.shopId)
          );
          if (self.rowInventories.length == 0) {
            self.$message({
              message: self.$t("inventory.inventoryInfoNoExist"),
              type: "warning",
            });
          } else {
            if (self.rowInventories.length == 1) {
              self.pickShelfObj.shopId = self.rowInventories[0].shopId;
              self.selectInventoryShop();
            }
            self.pickShelfDF = true;
          }
        } else {
          self.sysError();
        }
      });
    },
    selectInventoryShop() {
      let obj = this.rowInventories.find(
        (i) => i.shopId == this.pickShelfObj.shopId
      );
      this.pickShelfObj.shopName = obj.shopName;
      this.rowInventoryShelfs = obj.inventoryShelfs;
      this.rowInventoryShelfs.forEach((shelf) =>
        Vue.set(shelf, "text", shelf.shelfName + "(" + shelf.quantity + ")")
      );
      if (this.rowInventoryShelfs.length == 1) {
        this.pickShelfObj.shelfId = self.rowInventoryShelfs[0].shelfId;
        this.selectInventoryShelf();
      }
    },
    selectInventoryShelf() {
      const self = this;
      if (
        self.rowInventoryShelfs.length != 0 &&
        self.pickShelfObj.shelfId != null
      ) {
        const obj = self.rowInventoryShelfs.find(
          (i) => i.shelfId == self.pickShelfObj.shelfId
        );
        this.pickShelfObj.shelfName = obj.shelfName;
        self.pickShelfObj._maxQuantity =
          self.row.quantity > obj.quantity ? obj.quantity : self.row.quantity;
        return;
      }
    },
    pickShelfSubmit() {
      const self = this;
      self.$refs.pickShelfObjForm.validate((valid) => {
        if (valid) {
          if (
            !Util.regexQuantity(this.pickShelfObj.quantity) ||
            this.pickShelfObj.quantity == "0" ||
            this.pickShelfObj.quantity == 0 ||
            this.pickShelfObj.quantity > this.pickShelfObj._maxQuantity
          ) {
            this.$message({
              message: self.$t("rules.regex", [self.$t("text.quantity")]),
              type: "warning",
            });
            return;
          }
          self.pickShelfSubmitDoing = true;
          InventoryForceOut.agree(self.row.id, self.pickShelfObj).then(
            function (res) {
              self.pickShelfSubmitDoing = false;
              self.pickShelfDF = false;
              if (res.status === 200) {
                self.sysResult(res.data);
                // self.$message({
                //   message: self.$t("prompt.stockOutSuccess"),
                //   type: "success",
                // });
                self.loadData();
                self.$eventHub.$emit("inventoryForceOutAgree");
              } else {
                self.sysError();
              }
            }
          );
        } else {
          return false;
        }
      });
    },

    ignore(row) {
      const self = this;
      self.ignoreDoing = true;
      InventoryForceOut.ignore(row.id).then(function (res) {
        self.ignoreDoing = false;
        if (res.status === 200) {
          // self.sysResult(res.data);
          self.$message({
            message: self.$t("prompt.ignoreSuccess"),
            type: "success",
          });
          self.loadData();
          self.$eventHub.$emit("inventoryForceOutIgnore");
        } else {
          self.sysError();
        }
      });
    },

    // 可选
    checCheckboxMethod({ row }) {
      if (row.dealAt == null) {
        return true;
      }
      return false;
    },
    //-----
    dataProvider(params) {
      return InventoryForceOut.search(params);
    },
  },
};
</script>
